// @index(d:!,!Context): export { default as ${variable}} from ${relpath}
export { default as CollectionEditor } from './CollectionEditor'
// /index

// @index(d:!,!Context): export type {Props as ${variable}Props} from ${relpath}
export type {Props as CollectionEditorProps } from './CollectionEditor'
// /index